function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import truckListTemplate from './subcomponents/template/c-truckResult.js';
import noResultTemplate from './subcomponents/template/c-noResult.js';
import errorTemplate from './subcomponents/template/c-error.js';
import loadingTemplate from './subcomponents/template/c-loading.js';
import { getTmsInstance } from 'integration-web-core--socle/js/assets/commons/_tms.js';
import { CookieStore } from './setStore.class';
import GenericalLoader from 'integration-web-core--socle/js/assets/modules/_genericalLoader.class';
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import { Sanitize } from './utils/sanitize';
var TruckApp = /*#__PURE__*/function () {
  function TruckApp(searchModule) {
    var _this = this;
    _classCallCheck(this, TruckApp);
    this.mainTitle = document.querySelector('[data-cerberus="TITLE_truckrental"]').innerHTML.trim();
    if (document.getElementById('searchModule')) {
      this.sanitizer = new Sanitize();
      this.SearchModule = searchModule;
      this.SearchModule.initializeStartDatePicker();
      this.searchTruckBtn = document.querySelector('.js-searchTruck');
      this.searchFormError = document.querySelector('.search-form-error');
      if (this.searchTruckBtn) {
        this.clickOnSearchButton();
      }
      this.searchResultInformation = document.querySelector('.search-module__result');
    }
    this.loaderObj = new GenericalLoader();
    this.accordion();
    var appButtons = document.querySelectorAll('.js-partner-app');
    if (appButtons) {
      var _iterator = _createForOfIteratorHelper(appButtons),
        _step;
      try {
        var _loop = function _loop() {
          var appButton = _step.value;
          var href = appButton.getAttribute('href');
          var url = new URL(href);
          var appName = url.hostname === 'apps.apple.com' ? 'App store' : 'Google Play';
          appButton.setAttribute('data-appname', appName);
          appButton.addEventListener('click', function () {
            _this.sendTracking(_this.mainTitle, appButton.dataset.appname);
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    this.changeStoreBtn = document.querySelector('.js-choose-store');
    if (this.changeStoreBtn) {
      this.changeStoreBtn.addEventListener('click', function (event) {
        lm.MobileAppBridge('CONTEXT_STORE_SELECTION', null).then(function (result) {
          // if native app does not consume the event, open the web page
          if (!result) {
            event.preventDefault();
            window.dispatchEvent(new CustomEvent('openStoreContextLayerInSearchMode'));
          }
        })
        // if an error occured, throw an error
        ["catch"](function (error) {
          throw new Error("Error : ".concat(error));
        });
      });
    }
  }
  return _createClass(TruckApp, [{
    key: "accordion",
    value: function accordion() {
      this.myAccordions = document.querySelectorAll('.js-accordion');
      try {
        if (this.myAccordions) {
          for (var i = 0; i < this.myAccordions.length; i++) {
            new Accordion(this.myAccordions[i]);
          }
        }
      } catch (error) {
        throw new Error("Error : ".concat(error));
      }
    }
  }, {
    key: "clickOnSearchButton",
    value: function clickOnSearchButton() {
      var _this2 = this;
      this.searchTruckBtn.addEventListener('click', function (event) {
        event.preventDefault();
        _this2.getSearchResult();
      });
    }
  }, {
    key: "showLoader",
    value: function showLoader() {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (loading) {
        if (document.querySelector('.js-loading') === null) {
          this.searchTruckBtn.style.display = 'none';
          document.querySelector('.js-searchTruckContainer').insertAdjacentHTML('beforeend', lm.template(loadingTemplate));
          this.loaderObj.append(document.querySelector('.js-loader-container'));
        }
      } else {
        this.searchTruckBtn.removeAttribute('style');
        var element = document.querySelector('.js-loading');
        element.parentNode.removeChild(element);
      }
    }
  }, {
    key: "searchResultInformationHandler",
    value: function searchResultInformationHandler(error) {
      var _this3 = this;
      this.searchFormError && this.searchFormError.remove();
      if (!error) {
        var msg = document.querySelector('.js-truck-title');
        var selectElement = document.querySelector('.js-select-wrapper__input');
        var selectedStoreName = this.sanitizer.escapeHTML(selectElement.options[selectElement.options.selectedIndex].text);
        msg.style.opacity = 0;
        setTimeout(function () {
          var startDate = _this3.getStartDate();
          var endDate = _this3.getEndDate();
          msg.innerHTML = "\n          location du ".concat(startDate, " \xE0 ").concat(_this3.SearchModule.startHourPicker.hourValue, "\n          au ").concat(endDate, " \xE0 ").concat(_this3.SearchModule.endHourPicker.hourValue, ", retrait dans votre magasin de ").concat(selectedStoreName);
          msg.removeAttribute('style');
        }, 300);
        this.searchResultInformation.classList.remove('is-hidden');
        this.searchResultInformation.classList.add('is-visible');
        this.showLoader(false);
      } else {
        var form = document.querySelector('.js-truck-search-form');
        form.insertAdjacentHTML('afterend', "<div class=\"search-form-error oss-text-danger mu-mt-100\"><svg class=\"ku-icon-16 oss-fill-red mu-mr-050\" aria-hidden=\"true\"><use href=\"#Navigation_Control_Cross_24px\"></use></svg>".concat(JSON.parse(error).message, "</div>"));
      }
    }
  }, {
    key: "getSearchResult",
    value: function getSearchResult() {
      var _this4 = this;
      var prmAlternative = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var element = document.querySelector('#truckTypes');
      var truckType = this;
      this.showLoader();
      this.SearchModule.submitFormular(prmAlternative).then(function (response) {
        if (prmAlternative !== '') {
          var objTracking = {
            categorie: 'module location de vehicule',
            action: "alternative : ".concat(prmAlternative),
            label: "".concat(_this4.SearchModule.startDatePicker.dateValue.split('/').reverse().join('-'), "|").concat(_this4.SearchModule.endDatePicker.dateValue.split('/').reverse().join('-'), "|").concat(_this4.SearchModule.startHourPicker.hourValue.toString(), "|").concat(_this4.SearchModule.endHourPicker.hourValue.toString())
          };
          getTmsInstance().pushEvent(window, 'gaEvent', objTracking);
        } else {
          truckType.manageTracking(response);
        }
        truckType.manageSearchResult(response, element);
        _this4.searchResultInformationHandler();
      })["catch"](function (error) {
        console.error(error);
        // display error when endDate isBefore startDate or if the reservation date is in past
        _this4.searchResultInformationHandler(error);
        _this4.SearchModule.enableSubmission();
        if (element !== null && prmAlternative === '') {
          element.innerHTML = '';
        }
        element.insertAdjacentHTML('beforeend', lm.template(errorTemplate));
        _this4.showLoader(false);
      });
    }
  }, {
    key: "appendLoaderAlternative",
    value: function appendLoaderAlternative(btn) {
      var container = btn.parentElement;
      var p = document.createElement('p');
      container.removeChild(btn);
      p.classList.add('m-loader__wrapper');
      this.loaderObj.append(p);
      p.insertAdjacentText('beforeend', 'Recherche en cours');
      container.insertAdjacentElement('beforeend', p);
    }
  }, {
    key: "manageSearchResult",
    value: function manageSearchResult(prmJson, prmElement) {
      var _this5 = this;
      var element = prmElement;
      if (element !== null) {
        element.innerHTML = '';
      }

      //On récupère le storeId qu'on met sur 3 chiffres si
      var cookieStoreObj = new CookieStore();
      var storeId = cookieStoreObj.getStore().padStart(3, '0');

      //On récupère les paramètres de l'utilisateur pour construire l'URL de réservation
      var startDate = "".concat(this.SearchModule.startDatePicker.dateValue.split('/').reverse().join('-'), "T").concat(this.SearchModule.startHourPicker.hourValue.toString(), ":00");
      var endDate = "".concat(this.SearchModule.endDatePicker.dateValue.split('/').reverse().join('-'), "T").concat(this.SearchModule.endHourPicker.hourValue.toString(), ":00");
      var json = JSON.parse(prmJson);
      if (Object.keys(json.trucks).length === 0) {
        element.insertAdjacentHTML('beforeend', lm.template(noResultTemplate, {
          date: json.alternativeDate
        }));
        if (json.alternativeDate) {
          document.querySelector('button[name="changeDate"]').addEventListener('click', function (e) {
            _this5.appendLoaderAlternative(e.target);
            _this5.SearchModule.setPickers({
              start: json.alternativeDate.date,
              end: json.alternativeDate.date
            }, {
              start: json.alternativeDate.startTime,
              end: json.alternativeDate.endTime
            });
            var startDate = _this5.getStartDate();
            var endDate = _this5.getEndDate();
            _this5.onAlternative = "selon vos disponibilit\xE9s :\n          du ".concat(startDate, " \xE0 ").concat(_this5.SearchModule.startHourPicker.hourValue, "\n          au ").concat(endDate, " \xE0 ").concat(_this5.SearchModule.endHourPicker.hourValue);
            _this5.getSearchResult('dates');
          });
        }
      } else {
        var trucks = json.trucks;
        var container = document.createElement('div');
        container.classList.add('ml-container');
        var containerFlexy = document.createElement('ul');
        containerFlexy.classList.add('ml-flexy', 'ml-flexy--gutter');
        container.insertAdjacentElement('beforeend', containerFlexy);
        for (var i = 0; i < trucks.length; i++) {
          trucks[i].storeId = storeId;
          trucks[i].startDate = startDate;
          trucks[i].endDate = endDate;
          containerFlexy.insertAdjacentHTML('beforeend', lm.template(truckListTemplate, trucks[i]));
        }
        setTimeout(function () {
          _this5.truckListTracking();
        }, 1000);
        element.insertAdjacentElement('beforeend', container);
      }
      var pageLoader = document.querySelector('.page-loader');
      if (pageLoader) {
        pageLoader.parentNode.removeChild(pageLoader);
      }
    }
  }, {
    key: "manageTracking",
    value: function manageTracking(prmJson) {
      var json = JSON.parse(prmJson);
      //Par défaut on a du résultat
      var value = 'result';
      if (Object.keys(json.trucks).length === 0) {
        //Pas de résultat
        value = 'no result';
      }
      var objTracking = {
        categorie: 'module location de vehicule',
        action: "r\xE9sultat : ".concat(value),
        label: "".concat(this.SearchModule.startDatePicker.dateValue.split('/').reverse().join('-'), "|").concat(this.SearchModule.endDatePicker.dateValue.split('/').reverse().join('-'), "|").concat(this.SearchModule.startHourPicker.hourValue.toString(), "|").concat(this.SearchModule.endHourPicker.hourValue.toString())
      };
      getTmsInstance().pushEvent(window, 'gaEvent', objTracking);
    }
  }, {
    key: "truckListTracking",
    value: function truckListTracking() {
      setTimeout(function () {
        return true;
      }, 1000);
      var bookButtons = document.querySelectorAll('.js-reserve-truck');
      if (bookButtons) {
        var _loop2 = function _loop2(i) {
          bookButtons[i].addEventListener('click', function () {
            var truckName = bookButtons[i].dataset.truckname;
            var objTracking = {
              categorie: 'Ajout panier',
              action: "".concat(truckName),
              label: 'location d’utilitaire'
            };
            getTmsInstance().pushEvent(window, 'gaEvent', objTracking);
          });
        };
        for (var i = 0; i < bookButtons.length; i++) {
          _loop2(i);
        }
      }
    }
  }, {
    key: "getStartDate",
    value: function getStartDate() {
      var startDateFormatted = this.SearchModule.startDatePicker.dateValue.toString();
      if (startDateFormatted.includes('-')) {
        startDateFormatted = startDateFormatted.split('-').reverse().join('/');
      }
      return startDateFormatted;
    }
  }, {
    key: "getEndDate",
    value: function getEndDate() {
      var startEndFormatted = this.SearchModule.endDatePicker.dateValue.toString();
      if (startEndFormatted.includes('-')) {
        startEndFormatted = startEndFormatted.split('-').reverse().join('/');
      }
      return startEndFormatted;
    }
  }, {
    key: "sendTracking",
    value: function sendTracking(buttonvalue, buttonlabel) {
      var trackingObj = {
        event_name: 'button.click',
        event_data: {
          button_value: "".concat(buttonvalue),
          button_type: 'service',
          button_name: "".concat(buttonlabel)
        }
      };
      getTmsInstance().pushEvent(document, 'cdl_event', trackingObj);
    }

    /**
     *
     * @param {Node} prmElement
     */
  }, {
    key: "removeErrorOnForm",
    value: function removeErrorOnForm(prmElement) {
      if (prmElement.tagName === 'SELECT') {
        prmElement.closest('div.js-select-wrapper').classList.remove('is-invalid');
      } else {
        prmElement.classList.remove('is-invalid');
      }
      var parent = prmElement.closest('.js-form');
      if (parent) {
        var childToRemove = parent.querySelector('.km-field__message');
        if (childToRemove) {
          parent.removeChild(childToRemove);
        }
      }
    }
  }]);
}();
export default TruckApp;